module.exports = __webpack_public_path__ + "media/assets/images/category/IndepdenceDay@2x-6072db634597cc23c69fbce5b787d8f2.png";